export default "__VITE_ASSET__DUsDdGcX__"